import AnalyticsWebClient from '@atlassiansox/analytics-web-client/client';

import { getEnvironment } from './getEnvironment';
import { state } from './state';

const getAnalyticsClient: () => InstanceType<typeof AnalyticsWebClient> = (() => {
	let instance: InstanceType<typeof AnalyticsWebClient> | undefined;
	return (): InstanceType<typeof AnalyticsWebClient> => {
		if (!instance) {
			const env = getEnvironment();

			instance = new AnalyticsWebClient({ env, product: 'observability' });
		}
		return instance;
	};
})();

/**
 * Sets the active trace context.
 * This function should be called when starting a new trace to establish
 * the trace context that will be propagated to downstream operations.
 *
 * @param traceId - The trace ID to set
 * @param spanId - The span ID to set
 * @param source - The calling package/experience/what-have-you. EG 'jira.fe.backlog.create-issue_bm3'
 *
 * @example
 * ```typescript
 * setActiveTrace('9ad3407c1a7d484b86847e7226e566d3', '84a67a1b3ceccf27', 'bm3_jira.fe.inline-result.backlog.issue-create');
 * ```
 */
export function setActiveTrace(traceId: string, spanId: string, source: string): void {
	// If trace context has already been set, there has been an experience collision
	// Don't update the trace context.
	if (state.context !== null) {
		getAnalyticsClient().sendOperationalEvent({
			source,
			action: 'setActiveTrace',
			actionSubject: 'traceContext',
			attributes: {
				currentContext: state.context,
				incomingContext: { traceId, spanId },
				status: 'collision',
			},
			tags: ['observability'],
		});
	} else {
		state.context = {
			traceId,
			spanId,
		};
	}
}
